import { render, staticRenderFns } from "./ReportKardex.vue?vue&type=template&id=5450324b&scoped=true"
import script from "./ReportKardex.vue?vue&type=script&lang=js"
export * from "./ReportKardex.vue?vue&type=script&lang=js"
import style0 from "./ReportKardex.vue?vue&type=style&index=0&id=5450324b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5450324b",
  null
  
)

export default component.exports